import { ClipboardArrowUpOutlineIcon } from './ClipboardArrowUpOutlineIcon';

/**
 * author: James Coyle
 * id 15ED4DA3-08C5-4913-9FEB-A88CEED7DDE9
 * name clipboard-arrow-up-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-arrow-up-outline.svg
 * tags
 */
export const ClipboardArrowTopOutlineIcon = ClipboardArrowUpOutlineIcon;
export default ClipboardArrowTopOutlineIcon